import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const isGreek = location.pathname.startsWith('/el');
    const newLang = isGreek ? 'el' : 'en';
    setLang(newLang);

    // Update Document Meta for SEO
    document.documentElement.lang = newLang;
    document.title = newLang === 'el' ? 'IzziSEO - Premium Υπηρεσίες' : 'IzziSEO - Premium Services';
  }, [location.pathname]);

  const toggleLanguage = (newLang) => {
    if (newLang === lang) return;
    if (newLang === 'el') {
      navigate('/el' + location.pathname.replace(/^\/en/, ''));
    } else {
      navigate(location.pathname.replace(/^\/el/, '') || '/');
    }
  };

  const t = (key) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (let k of keys) {
      if (val) val = val[k];
    }
    return val || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);